export default __webpack_public_path__ + "static/media/0195.d5e5b476.jpg";